import { Cascader, Field, Popup } from "vant"
import { computed, defineComponent, ref } from "vue"
import styles from "./index.module.less"

export default defineComponent({
  name: "MobileCascader",
  props: {
    modelValue: { type: [String, Number] },
    options: { type: Array, default: () => [] },
    placeholder: String,
    disabled: Boolean,
    title: String,
    config: { type: Object, default: () => ({}) },
    selectRandom: { type: Boolean, default: false } //是否开启选择任意一级
  },
  emits: ["update:modelValue", "change"],
  setup(props, { emit, slots }) {
    const visible = ref(false)

    const insideValue = computed({
      get() {
        return props.modelValue
      },
      set(value) {
        emit("update:modelValue", value)
      }
    })

    const fieldNames = computed(() => {
      const { fieldNames } = props.config
      return {
        text: "text",
        value: "value",
        children: "children",
        ...fieldNames
      }
    })

    const pointers = computed(() => {
      const pointers = {}
      const { value: valueKey, children: childrenKey } = fieldNames.value
      let options = [...props.options]
      while (options.length > 0) {
        const current = options.shift()
        const { [valueKey]: value, [childrenKey]: children = [] } = current
        options = [...options, ...children]
        children.forEach((item) => (item.parent = current))
        pointers[value] = current
      }
      return pointers
    })

    const popupProps = computed(() => {
      return {
        round: true,
        closeOnPopstate: true,
        position: "bottom",
        teleport: "body",
        closeable: false
      }
    })

    const cascaderProps = computed(() => {
      return {
        options: props.options,
        title: props.title || props.placeholder,
        ...props.config,
        closeable: !props.selectRandom,
        class: props.selectRandom ? styles.CasSelectRandom : "",
        onChange: (value) => {
          const children =
            value.selectedOptions[value.selectedOptions.length - 1][
              fieldNames.value.children
            ] || []
          if (!children.length) {
            visible.value = false
          }
          emit("change", value)
        },
        onClose: () => {
          visible.value = false
        },
        onFinish: (value, selectedOptions, tabIndex) => {
          visible.value = false
        }
      }
    })

    const casSlots = {
      title: () => {
        if (props.selectRandom) {
          return (
            <div class={"flex--a-c--j-sb"}>
              <h2 class="van-cascader__title">
                {props.title || props.placeholder}
              </h2>
              <div
                class={styles.finish}
                onClick={() => (visible.value = false)}
              >
                完成
              </div>
            </div>
          )
        } else {
          return (
            <h2 class="van-cascader__title">
              {props.title || props.placeholder}
            </h2>
          )
        }
      }
    }

    const showValue = computed(() => {
      const pointer = insideValue.value
      const { text: textKey } = fieldNames.value
      let current = pointers.value[pointer] || { text: "" }
      const values = []
      while (current) {
        values.unshift(current[textKey])
        current = current.parent
      }
      return values.join(" / ")
    })

    const show = () => {
      if (!props.disabled) visible.value = true
    }

    const fieldProps = computed(() => {
      return {
        readonly: true,
        disabled: props.disabled,
        rightIcon: props.disabled ? "" : "arrow",
        placeholder: props.placeholder,
        class: styles.input,
        onClick: show
      }
    })

    return () => (
      <div style="width:inherit">
        {slots.default ? (
          <div onClick={show}>{slots.default()}</div>
        ) : (
          <Field {...fieldProps.value} modelValue={showValue.value} />
        )}
        <Popup vModel:show={visible.value} {...popupProps.value}>
          <Cascader
            vModel={insideValue.value}
            {...cascaderProps.value}
            vSlots={casSlots}
          />
        </Popup>
      </div>
    )
  }
})
